const updateCountryLabels = () => {
  const countryCode = window.Shopify?.country?.toUpperCase();

  if (!countryCode || !/^[A-Z]{2}$/.test(countryCode)) return;

  document.querySelectorAll('[data-testid="localization-currency-code"]').forEach((label) => {
    if (label.textContent.trim() !== countryCode) {
      label.textContent = countryCode;
    }
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', updateCountryLabels, { once: true });
} else {
  updateCountryLabels();
}

document.addEventListener('shopify:section:load', updateCountryLabels);

new MutationObserver(updateCountryLabels).observe(document.documentElement, {
  childList: true,
  subtree: true,
});
